<template>
  <section class="result-block">
    <div class="container">
      <div class="result-intro">
        <h1 class="headline headline--1 headline-icon">
          <span class="label">Ergebnis deines Gründertests</span>
          <span class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 162 205.2">
              <path
                d="M28.9,91H43.5v14.6H28.9Zm0,40H43.5V116.5H28.9Zm0-50.9H43.5V65.6H28.9Zm69.3,39.6H54.6V127H98.2Zm0-50.9H54.6v7.3H98.2Zm0,25.4H54.6v7.3H98.2ZM162,165.3a40.1,40.1,0,0,1-79.8,5.3H18.9A18.9,18.9,0,0,1,0,151.7V32.8A18.8,18.8,0,0,1,18.9,14.2H45.7l.3-.9A18.8,18.8,0,0,1,81.9,13v1h26.4a18.9,18.9,0,0,1,18.9,18.8v92.9A40.1,40.1,0,0,1,162,165.3ZM41.9,40.6H85.3v-16H71.8V19.3a3.8,3.8,0,0,0,0-1.5,8.2,8.2,0,0,0-16.4,1.5v5.3H41.9ZM82.2,159.9a40,40,0,0,1,34.7-34.2h0V32.8a8.2,8.2,0,0,0-8.2-8.2H96.5V51.3H31.4V24.6H18.9a8.3,8.3,0,0,0-8.3,8.2V151.7a8.2,8.2,0,0,0,8.3,8.2Zm70.4,5.4a30.7,30.7,0,1,0-30.7,30.5A30.7,30.7,0,0,0,152.6,165.3Zm-15.8-15.2-19.1,20.8-10.4-10.1-5.2,5.4,16,15.4,24.2-26.5Z"
              />
            </svg>
          </span>
        </h1>
        <div class="bodytext">
          <p class="intro">
            Fertig. Du hast mit dem Gründertest wichtige Unternehmer-Eigenschaften abgeklopft. Dabei ist wichtig zu beachten, dass du nicht überall perfekt sein
            musst. Deine Stärken und Schwächen zu kennen, hilft dir, deine Gründung besser vorzubereiten und als Unternehmer erfolgreicher zu sein.
          </p>
        </div>

        <h2 class="headline headline--2">Dein Chance-Risiko-Profil</h2>
        <div class="bodytext">
          <p>
            In der Grafik siehst du, welche Bereiche bei dir derzeit eher Chance oder Risiko sind. Auf die Risiko-Themen solltest du besonderes Augenmerk legen.
            Im Anschluss erhältst du mehr Details zu allen Bereichen. Und Tipps, die dir helfen, die Risiken zu reduzieren.
          </p>
        </div>
      </div>
      <div class="results-graphic">
        <div class="result good">
          <h2 class="headline headline--2">Chance</h2>
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="59.3" viewBox="0 0 60 59.3">
              <ellipse class="bg" cx="30" cy="29.7" rx="27.5" ry="27.2" />
              <ellipse cx="20.4" cy="21.4" rx="4.3" ry="4.3" />
              <ellipse cx="39.8" cy="21.4" rx="4.3" ry="4.3" />
              <path d="M41,40.6a16.3,16.3,0,0,1-4.9,3.3A17.4,17.4,0,0,1,30,45.1a17.4,17.4,0,0,1-6.1-1.2A16.3,16.3,0,0,1,19,40.6" />
            </svg>
          </div>
          <ul class="list list--hook">
            <li class="label no--value" v-if="clusterResultsRating(userSelections['clusterScore'], 'good').length === 0">
              <span>–</span>
            </li>
            <li class="label" v-for="cluster in clusterResultsRating(userSelections['clusterScore'], 'good')" :key="cluster.id">
              <span>
                {{ cluster["name"] }}
              </span>
            </li>
          </ul>
        </div>
        <div class="result mid">
          <h2 class="headline headline--2">Neutral</h2>
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="59.3" viewBox="0 0 60 59.3">
              <ellipse class="bg" cx="30" cy="29.7" rx="27.5" ry="27.2" />
              <ellipse cx="20.4" cy="21.4" rx="4.3" ry="4.3" />
              <ellipse cx="39.8" cy="21.4" rx="4.3" ry="4.3" />
              <line x1="23" y1="41.6" x2="37" y2="41.6" />
            </svg>
          </div>
          <ul class="list list--hook">
            <li class="label no--value" v-if="clusterResultsRating(userSelections['clusterScore'], 'mid').length === 0">
              <span>–</span>
            </li>
            <li class="label" v-for="cluster in clusterResultsRating(userSelections['clusterScore'], 'mid')" :key="cluster.id">
              <span>{{ cluster["name"] }}</span>
            </li>
          </ul>
        </div>
        <div class="result bad">
          <h2 class="headline headline--2">Risiko</h2>
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="59.3" viewBox="0 0 60 59.3">
              <ellipse class="bg" cx="30" cy="29.7" rx="27.5" ry="27.2" />
              <ellipse cx="20.4" cy="21.4" rx="4.3" ry="4.3" />
              <ellipse cx="39.8" cy="21.4" rx="4.3" ry="4.3" />
              <path d="M23.9,42.1a16.1,16.1,0,0,1,12.2,0" />
            </svg>
          </div>

          <ul class="list list--hook">
            <li class="label no--value" v-if="clusterResultsRating(userSelections['clusterScore'], 'bad').length === 0">
              <span>–</span>
            </li>
            <li class="label" v-for="cluster in clusterResultsRating(userSelections['clusterScore'], 'bad')" :key="cluster.id">
              <span>{{ cluster["name"] }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="evaluation-block">
    <div class="container">
      <div class="result-advice" v-for="cluster in userSelections['clusterScore']" :key="cluster.id">
        <div class="result-intro">
          <h3 class="headline headline--3 headline-topic">{{ cluster["name"] }}</h3>
          <div class="bodytext">
            <p v-html="clusterResults(cluster)"></p>
          </div>
        </div>

        <div class="advice-box" v-if="clusterIdFilter(cluster['clusterId'], userSelections['foundertestanswer']).length > 0">
          <h4 class="headline headline--4 headline-advice">Unser Rat</h4>
          <div class="bodytext">
            <ul class="list list--arrow">
              <li v-for="item in clusterIdFilter(cluster['clusterId'], userSelections['foundertestanswer'])" :key="item">
                <span v-html="item['advice']"></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="advice-block">
    <div class="container">
      <div class="tips">
        <h1 class="tips-person">
          <span class="figure">
            <figure>
              <img src="../assets/rene-klein.jpg" />
            </figure>
          </span>
          <span>Unsere Tipps für dich</span>
        </h1>
        <div class="bodytext">
          <p>
            Wir sprechen tagtäglich mit, erfolgreichen Startups und Beratern. Aufgrund unserer Erfahrung, möchten wir dir folgende Tipps/Gedankenanstöße geben:
          </p>
          <ul class="list list--arrow">
            <template v-for="hint of userSelections['founderteststartanswers']" :key="hint">
              <li v-if="hint['hintText']">
                <span v-html="hint['hintText']"></span>
              </li>
            </template>
          </ul>
        </div>
      </div>
      <div class="nextSteps">
        <h2 class="headline headline--2">Bist du bereit für den nächsten Schritt?</h2>
        <div class="bodytext">
          <p>
            Der Businessplan erhöht die Erfolgsaussichten für Gründer. Banken und Investoren verlangen ihn für eine Finanzierung. Um einen überzeugenden
            Business- und Finanzplan schnell und einfach schreiben zu können, haben wir den Unternehmerheld Businessplaner entwickelt. Die Softwarelösung hat
            schon vielen Gründern geholfen, ihren Traum vom eigenen Unternehmen zu verwirklichen.
          </p>
        </div>

        <a class="btn btn--big" target="_blank" href="https://www.unternehmerheld.de/plan/businessplan/businessplansoftware/">
          Businessplansoftware: kostenfrei & smart
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Results",
  data() {
    return {
      readyState: false,
      resultBad: 2.3,
      resultGood: 3.8,
    };
  },
  props: {
    userSelections: Object,
    foundertestclusters: Array,
  },
  mounted() {
    this.$gtag.pageview({
      page_title: "Gründertest machen - Ergebnisse",
      page_path: "https://www.fuer-gruender.de/wissen/existenzgruendung-planen/gruendertest-machen/results",
    });
  },
  methods: {
    clusterResultsRating(array, type) {
      array = Object.values(array);
      let filteredItems = [];
      filteredItems = [
        ...array.filter((c) => {
          if (type === "good") {
            return c["score"] / c["questions"] > this.resultGood;
          }
          if (type === "mid") {
            return c["score"] / c["questions"] >= this.resultBad && c["score"] / c["questions"] <= this.resultGood;
          }
          if (type === "bad") {
            return c["score"] / c["questions"] < this.resultBad;
          }
        }),
      ];
      return filteredItems;
    },
    test(c) {
      let result = "";
      // console.log(c["name"]);
      // console.log(c["score"] / c["questions"]);
      if (c["score"] / c["questions"] < this.resultBad) {
        result = "bad";
      }
      if (c["score"] / c["questions"] >= this.resultBad && c["score"] / c["questions"] <= this.resultGood) {
        result = "mid";
      }
      if (c["score"] / c["questions"] > this.resultGood) {
        result = "good";
      }
      return result;
    },
    clusterResults(c) {
      let result = "";
      // console.log(c["name"]);
      // console.log(c["score"] / c["questions"]);
      if (c["score"] / c["questions"] < this.resultBad) {
        result = c["resultBad"];
      }
      if (c["score"] / c["questions"] >= this.resultBad && c["score"] / c["questions"] <= this.resultGood) {
        result = c["resultAverage"];
      }
      if (c["score"] / c["questions"] > this.resultGood) {
        result = c["resultGood"];
      }
      return result;
    },
    clusterIdFilter(id, array) {
      array = Object.values(array);
      let filteredItems = [];
      filteredItems = [...array.filter((a) => a["clusterid"] === id)];
      filteredItems = [
        ...filteredItems.filter((a) => {
          if (a["advice"] !== null) {
            return true;
          }
        }),
      ];
      return filteredItems;
    },
  },
};
</script>
